import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { PureInput as Component } from './pure-input';
import type { TPureInput, IDeps } from './models';
import styles from './styles/styles.css';

export const PureInput = createWidget<IDeps, TPureInput>({
    styles,
})(Component);
